"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.every.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.reduce.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
// const files = require.context('./', false, /.js$/)
var _default = exports.default = {
  // mixins: files.keys().map(key => files(key).default).filter(file => file),
  data: function data() {
    return {
      openRequest: false,
      loadingRequest: [],
      autoPageSize: true,
      // 自动根据行高展示分页每页条目数量
      queryValue: '',
      table: {
        border: true,
        stripe: true,
        indent: 8,
        'highlight-current-row': true,
        'tree-props': {
          children: 'children',
          hasChildren: 'hasChildren'
        },
        // data                   : new Array(20).fill(0).map((item, index) => ({ id: index }))
        data: []
      },
      // 单选值
      selectionRadio: '',
      tableSelection: [],
      tableSelectionOld: [],
      tableRowOperations: [],
      // 记录展开状态
      tableTreeNode: {},
      loading: false
    };
  },
  filters: {
    rowOperationsLabel: function rowOperationsLabel(btn) {
      var _btn$name;
      return (_btn$name = btn.name) !== null && _btn$name !== void 0 ? _btn$name : btn.label;
    }
  },
  computed: {
    isFixedDatas: function isFixedDatas() {
      var _this$pagination = this.pagination,
        total = _this$pagination.total,
        pageSize = _this$pagination.pageSize;
      var l = this.datas.length;
      return (total === 0 || l === total) && l > pageSize && !this.renderPagination;
    },
    renderPagination: function renderPagination() {
      var a = this.$attrs.pagination;
      if (a === false || a === null) return false;
      var b = this.paginationOptions;
      if (b === false || b === null) return false;
      return true;
    },
    showPagination: function showPagination() {
      if (this.$attrs.pagination === 'auto' || this.paginationOptions === 'auto') return this.datas.length > this.pagination.pageSize;
      return this.pagination.show;
    }
  },
  watch: {
    /* 监听单选参数变化 */
    selectionRadio: {
      handler: function handler(nv, ov) {
        var _this = this;
        /* 只在单选模式下监听 */
        if (this.isSingle) {
          var item1 = this.table.data.find(function (v) {
            return nv === _this.getRowKey(v);
          });
          this.tableSelection = item1 ? [item1] : [];
          var item2 = this.table.data.find(function (v) {
            return ov === _this.getRowKey(v);
          });
          this.tableSelectionOld = item2 ? [item2] : [];
        }
      },
      deep: true
    },
    tableSelection: {
      handler: function handler(nv, ov) {
        if (this.isSingle) {
          this.selectionRadio = this.tableSelection.length === 0 ? '' : this.getRowKey(nv[0]);
        }
        /* 当前勾选行变动，被取消勾选的行 */
        /* 获取 变化后 的行 */
        var a = nv.map(function (item) {
          return JSON.stringify(item);
        });
        // /* 获取 变化前 的行 */
        // const b = ov.map(item => JSON.stringify(item))
        /* 判断差集 */
        var c = ov.filter(function (item) {
          return a.indexOf(JSON.stringify(item)) === -1;
        });
        this.tableSelectionOld = c;
        this.$$listenersEmit('selection-change', nv, c);
      },
      deep: true
    },
    columns: {
      handler: function handler() {
        var _this2 = this;
        this.$nextTick(function () {
          /* 监听表头变化重新渲染表格 */
          _this2.doLayout();
        });
      } /* nv, ov */,
      deep: true
    },
    'openRequest': function openRequest(nv) {
      var _this3 = this;
      nv && this.loadingRequest.forEach(function (r) {
        return _this3.getDatas(r.options, r.config);
      });
    },
    'table.data': function tableData(nv, ov) {
      var _this4 = this;
      if (nv) {
        if ((nv === null || nv === void 0 ? void 0 : nv.length) > 0 && nv.every(function (v) {
          return _this4.$$isEmpty(v);
        })) this.table.data = [];else {
          this.$$listenersEmit('change', nv, ov);
          this.$$listenersEmit('data-change', nv, ov);
          this.$$listenersEmit('datas-change', nv, ov);
        }
      }
    }
  },
  methods: {
    /**
     * @description: 组件初始化
     * @return { void }
     */
    init: function init() {
      this.renderData();
      this.initColumns();
      this.wacthTableSize();
      if (Array.isArray(this.datas)) this.renderData();
    },
    /** 初始化列数据
     * @description:
     * @return { void }
     */
    initColumns: function initColumns() {
      var _this$columns;
      (_this$columns = this.columns) === null || _this$columns === void 0 || _this$columns.forEach(function (item) {
        var _item$show;
        (_item$show = item.show) !== null && _item$show !== void 0 ? _item$show : item.show = true;
      });
    }
  },
  created: function created() {
    Object.assign(this.pagination, this.$store.state['wl-table-pagination']);
    this.init();
    // eslint-disable-next-line no-underscore-dangle
    if (!this.staticTable && this.dataSource.url && this.$parent.$options._componentTag !== 'wl-list') this.getDatas();
  },
  updated: function updated() {
    this.renderTable();
    // if (!this.staticTable && this.dataSource.url && this.dataSource?.auto) this.$$debounce(() => this.getDatas(), 1000)
  },
  beforeDestroy: function beforeDestroy() {
    var _this$$store;
    var p = this.pagination;
    var a = Object.keys(p).filter(function (key) {
      return 'pageSize,page-size'.includes(key);
    }).map(function (key) {
      return (0, _defineProperty2.default)({}, key, p[key]);
    });
    if ((_this$$store = this.$store) !== null && _this$$store !== void 0 && _this$$store.state) this.$store.state['wl-table-pagination'] = this.$$isNoEmpty(a, 'array') ? a.reduce(function (x, y) {
      return Object.assign(x, y);
    }) : {};
  }
};